import React from 'react';
import Styles from './BlogSection.module.less';

export type BlogSectionProps = {
    caption: string;
    children: React.ReactNode;
    link?: React.ReactNode;
};

export const BlogSection = ({
    link,
    caption,
    children,
}: BlogSectionProps): JSX.Element => {
    return (
        <div className="vertical left-top g56 lp-section">
            <div className="vertical stretch-top g40 self-stretch">
                <span>{caption}</span>
                <div className={Styles.posts}>{children}</div>
            </div>
            {link}
        </div>
    );
};
